export const transferringStateName = 'app.transferring';

export const transferringState = ($stateProvider) => {
  'ngInject';

  $stateProvider.state({
    abstract: true,
    name: transferringStateName,
    url: '/transferring',
    template: '<ui-view autoscroll/>'
  });
};

export const receivingStateName = 'app.receiving';

export const receivingState = ($stateProvider) => {
  'ngInject';

  $stateProvider.state({
    abstract: true,
    name: receivingStateName,
    url: '/receiving',
    template: '<ui-view autoscroll/>'
  });
};
